/* eslint-disable import/prefer-default-export */
import {
  STEPS,
  Step,
} from '@/components/brand-safety/connect-platform-wizard/wizardSteps';
import {stepsUuidMapGenerator} from '@/utils/stepsUuidMapGenerator';

export const CONNECT_PLATFORMS_STEPS_UUID_MAP =
  stepsUuidMapGenerator<Step>(STEPS);
